import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createStore from './reducks/store/store';
import './index.css';
import { ConnectedRouter } from 'connected-react-router';
import * as History from 'history';
import App from './App';
import reportWebVitals from './reportWebVitals';
// stripeを利用するためのモジュールをimport
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const history = History.createBrowserHistory();
export const store = createStore(history);

// 公開可能keyを設定して、 stripe objectを生成
const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY);

// Storeの値を監視する方法
// store.subscribe(() => console.log(store.getState()));

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();